import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../css/VideoDialog.css';


function ModalDialog(args) {
    var [videos, setVideos] = useState([]);
    var [srchArchiveName, setSrchArchiveName] = useState('');
    var [srchFolderName, setSrchFolderName] = useState('');
    var [srchVidName, setSrchVidName] = useState('');
    var [selectedRow, setSelectedRow] = useState('');
    const [loading, setLoading] = useState('');

    // Use useEffect to update the internal state when initialValue changes in props
    useEffect(() => {
        if (args.isOpen)
            setSrchVidName(args.defaultVideoName);
    }, [args.isOpen]); // Add isOpen as a dependency to ensure sync when modal opens

    async function searchVideo() {
        setLoading('loading');
        //console.log('Search video clicked. search value = ' + srchVidName);
        //let url = 'api/mediasearcher/FindMedia?';
        if (!(srchVidName || srchArchiveName || srchFolderName)) {
            alert('Please enter at least one search criteria');
            return;
        }
        let url = 'api/mediasearcher/GetChildren?';
        let params = {};
        if (srchVidName) {
            params.query = srchVidName;
        }
        if (srchArchiveName) {
            params.archiveName = srchArchiveName;
        }
        if (srchFolderName) {
            params.folderName = srchFolderName;
        }
 
        url += new URLSearchParams(params).toString();
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            data.forEach((video) => {
                video.creationDate = new Date(video.creationDate);
                video.size = formatFileSize(video.size);
            });
            setVideos(data);
        }
        else {
            console.error('Error in fetch call:', response.status, response.statusText);
        }
        setLoading('');
    }

    function okClicked() {
        args.toggle();
        args.onOk(selectedRow);
    }

    function formatFileSize(size) {
        let unit = 'bytes';
        if (size > 1024) {
            size /= 1024;
            unit = 'KB';
        }
        if (size > 1024) {
            size /= 1024;
            unit = 'MB';
        }
        return `${Math.round(size)} ${unit}`;
    }

    return (
        <Modal size="lg" {...args} className={`video-modal ${loading}`} >
            <ModalHeader toggle={args.toggle}>Find Video</ModalHeader>
            <ModalBody>
                <div class="mb-3">
                    <label for="srchVidName">Archive Name:</label>
                    <input type="text" class="form-control" placeholder="Search videos within Archive"
                        name="srchArchiveName" value={srchArchiveName} onChange={e => setSrchArchiveName(e.target.value)}></input>
                </div>
                <div class="mb-3">
                    <label for="srchFolderName">Folder Name:</label>
                    <input type="text" class="form-control" placeholder="Search videos under Folder"
                        name="srchFolderName" value={srchFolderName} onChange={e => setSrchFolderName(e.target.value)}></input>
                </div>
                <div class="mb-3">
                    <label for="srchVidName">Video Name:</label>
                    <input type="text" class="form-control" placeholder="Partial or Full Video Name"
                        name="srchVidName" value={srchVidName} onChange={e => setSrchVidName(e.target.value)}></input>
                </div>
                <div className="toolbar mb-3">
                    <button type="submit" class="btn btn-primary" onClick={searchVideo}>Submit</button>
                </div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr class="table-primary">
                            <th>Name</th>
                            <th>Creation Date</th>
                            <th>Size</th>
                            <th>File Path</th>
                        </tr>
                    </thead>
                    <tbody>
                        {videos.map((video, idx) =>
                            <tr key={idx} onClick={() => setSelectedRow(video.name)}
                                className={selectedRow === video.name ? 'table-success' : idx % 2 == 0 ? 'table-active' : 'table-light'}>
                                <td>{video.name}</td>
                                <td>{video.creationDate.toLocaleDateString('en-US', { dateStyle: 'short' })}</td>
                                <td>{video.size}</td>
                                <td>{video.filePath}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={okClicked}>
                    Ok
                </Button>{' '}
                <Button color="secondary" onClick={args.toggle}>
                    Cancel
                </Button>
            </ModalFooter>
            {loading && <div class='overlay'></div>}
        </Modal>
    );
}

export default ModalDialog;
